import type { Validator } from '@seek/validators-js';

export const MINIMUM_PASSWORD_LENGTH = 8;

export const consecutiveCharactersValidator = (
  errorMsg: string,
): Validator<string, Record<string, any>, Record<string, any>, string> => ({
  test: ({ value }) => !/(?=.*(.)\1\1).+/.test(value),
  getErrorMessage: async () => errorMsg,
  getErrorMessageSync: () => errorMsg,
  name: 'consecutiveCharacters',
});
